import { render, staticRenderFns } from "./columnsAdd.vue?vue&type=template&id=628a7d52&scoped=true"
import script from "./columnsAdd.vue?vue&type=script&lang=js"
export * from "./columnsAdd.vue?vue&type=script&lang=js"
import style0 from "./columnsAdd.vue?vue&type=style&index=0&id=628a7d52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628a7d52",
  null
  
)

export default component.exports